// routes/config/publicRoutes.ts
/**
 * Public Route Configuration
 * Routes accessible without authentication
 */

import { lazy } from 'react';
import { ROUTES } from '../../config/routes';
import type { RouteConfig } from '../types';

const PublicTimerPage = lazy(() => import('../../features/timer/pages/PublicTimerPage'));
const GuestLoginPage = lazy(() => import('../../features/guest/pages/GuestLoginPage'));
const GuestPortalPage = lazy(() => import('../../features/guest/pages/GuestPortalPage'));
const PublicPairingsPage = lazy(() => import('../../features/public/pages/PublicPairingsPage'));
const JoinTournamentPage = lazy(() => import('../../features/staff/pages/JoinTournamentPage'));
const PrivacyPolicyPage = lazy(() => import('../../features/legal/pages/PrivacyPolicyPage'));
const TermsPage = lazy(() => import('../../features/legal/pages/TermsPage'));
const ImpressumPage = lazy(() => import('../../features/legal/pages/ImpressumPage'));
const BotPrivacyPage = lazy(() => import('../../features/legal/pages/BotPrivacyPage'));
const DQParticipantFormPage = lazy(() => import('../../features/dq-cases/pages/DQParticipantFormPage'));

export const publicRoutes: RouteConfig[] = [
  {
    path: ROUTES.PUBLIC_TIMER,
    element: PublicTimerPage,
    auth: 'open',
  },
  {
    path: ROUTES.GUEST_LOGIN,
    element: GuestLoginPage,
    auth: 'open',
  },
  {
    path: ROUTES.GUEST_PORTAL,
    element: GuestPortalPage,
    auth: 'open',
  },
  {
    path: '/public/tournament/:tournamentId',
    element: PublicPairingsPage,
    auth: 'open',
  },
  {
    path: ROUTES.JOIN_TOURNAMENT,
    element: JoinTournamentPage,
    auth: 'optional', // Pass user if available
  },
  {
    path: ROUTES.PRIVACY_POLICY,
    element: PrivacyPolicyPage,
    auth: 'open',
  },
  {
    path: ROUTES.TERMS,
    element: TermsPage,
    auth: 'open',
  },
  {
    path: ROUTES.IMPRESSUM,
    element: ImpressumPage,
    auth: 'open',
  },
  {
    path: ROUTES.BOT_PRIVACY,
    element: BotPrivacyPage,
    auth: 'open',
  },
  {
    // Public DQ-case participant magic-link form. The token in the URL
    // is the proof of access; rules accept the form write when the
    // payload's qrToken matches the assignment's stored qrToken.
    path: ROUTES.DQ_PARTICIPANT_FORM,
    element: DQParticipantFormPage,
    auth: 'open',
  },
];
